"use strict";

var googleMapsLoaded = false;

function initAnimation() {
  initParallax();
  initToShow();
}

function initMaps() {
  googleMapsLoaded = true;

  if ($('.js-map-lawyer').length) {
    initMapLawyer();
  }

  if ($('.js-map-network').length) {
    initMapLawyers();
  }
}

$(function () {
  if ($('#region_news').length) {
    inputRegion();
    checkUrlParameters(regionsArray, 'regions');
  }

  if ($('#author_news').length) {
    inputAuthor();
    checkUrlParameters(authorsArray, 'authors');
  }

  if ($('.js-search-city').length) {
    showPlaces();
  }

  if ($('.js-search').length) {
    $('.js-search').getCoords();
  }

  if ($('.js-search').length) {
    $('.js-search').initSearch();
  }

  if ($('.js-show-search').length) {
    $('.js-show-search').showSearch();
  }

  lawyerHeader();
  initCarousel();
  initAnimation();
  asyncImg(function () {
    initAnimation();
  });
  asyncBg(function () {
    initAnimation();
  });

  if ($('.js-map-listing').length) {
    $('.js-map-lawyers').on('click', function () {
      vueLawyers.init(); // $('.js-firm-lawyers').addClass('hidden');
      // $('.js-office').removeClass('selected');
    }); // $('.js-close-firm').on('click', function(){
    //   vueLawyers.init();
    //   $('.js-firm-lawyers').addClass('hidden');
    // });
    // $('.js-map-listing').mapWidth();
  }

  $('.js-map-offices').on('click', function () {
    vueFirms.init(); // $('.js-map-listing').mapWidth();
    // $('.js-lawyer').removeClass('selected');
  });
  $window.on('scroll', function (e) {
    e.preventDefault();
    wt = $window.scrollTop();
    wb = wt + wh;
    ft = $footer.offset().top;
    lawyerHeader(); // if ($('.js-map-listing').length) {
    //   initMapWidth();
    // }
  });
  $window.on('resize', function () {
    var wh = $window.height();
    var ww = $window.width();
    var wt = $window.scrollTop();
    var wb = wt + wh;
    var wRatio = ww / wh;
    var ft = $footer.offset().top; // if ($('.js-map-listing').length) {
    //   initMapWidth();
    // }
  });
});